/* eslint-disable */
"use strict";
import errorService from "@/services/errorService";
import { fetchTO } from "@/components/helpers";
// const service = process.env.VUE_APP_service_stampante || '' // usato solo per installazione su Windows 32bit (senza IIS con reverse proxy)
var config, arrService, tipoDriver;
(async () => {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  arrService = [];
  if (config.service_stampante) {
    arrService.push(config.service_stampante);
  }
  let st = 1;
  while (config[`service_stampante${String(st).padStart(2, "0")}`]) {
    arrService.push(config[`service_stampante${String(st).padStart(2, "0")}`]);
    st++;
  }
  // service = config.service_stampante || process.env.VUE_APP_service_stampante
})();

async function getRunMode(numStampante) {
  const service = numStampante ? arrService[numStampante - 1] : arrService[0];
  try {
    const response = await fetchTO(`${service}/mode`);
    const result = await response.json();
    if (result.status === 404) {
      return defaultRunMode();
    }
    return result;
  } catch {
    return defaultRunMode();
  }
}

function defaultRunMode() {
  return {
    modulo: "STAMPANTE",
    locale: "---",
    remote: "---",
    versione: "---",
    health: "---",
  };
}

async function printRigaScontrino(idScontrino, riga) {
  console.log("printRigaScontrino se immediata", riga);
  // return await response.json()
  return { msg: "ok" };
}

async function stampaScontrino(
  idScontrino,
  scontrino,
  infoChiusuraScontrino,
  ultimoComando,
  numStampante,
) {
  const service = numStampante ? arrService[numStampante - 1] : arrService[0];
  const data = {
    righe: scontrino,
    info: infoChiusuraScontrino,
    ultimoComando: ultimoComando, // per gestione ristampa (per adesso solo EPSON)
  };
  try {
    console.log("Stampante service: stampaScontrino");
    const response = await fetch(`${service}/scontrino/${idScontrino}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    return result;
  } catch (error) {
    errorService.onError(error, "stampaScontrino");
    throw error;
  }
}

async function stampaScontrinoCortesia(barcode, numStampante) {
  const service = numStampante ? arrService[numStampante - 1] : arrService[0];
  const data = {
    barcode,
  };
  try {
    const response = await fetch(`${service}/scontrino/cortesia`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    errorService.onError(error, "stampaScontrinoCortesia");
    throw error;
  }
}

async function stampaScontrinoSoloReso(
  scontrino,
  infoChiusuraScontrino,
  ultimoComando,
  numStampante,
) {
  const service = numStampante ? arrService[numStampante - 1] : arrService[0];
  const data = {
    righe: scontrino,
    info: infoChiusuraScontrino,
    ultimoComando: ultimoComando, // per gestione ristampa (per adesso solo EPSON)
  };
  try {
    const response = await fetch(`${service}/scontrino/soloreso`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    return result;
  } catch (error) {
    errorService.onError(error, "stampaScontrinoSoloReso");
    throw error;
  }
}

async function stampaScontrinoGestionale(righe, barcode, numStampante) {
  const service = numStampante ? arrService[numStampante - 1] : arrService[0];
  const data = {
    righe,
    barcode: barcode,
  };
  try {
    const response = await fetch(`${service}/gestionale/generico`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    errorService.onError(error, "stampaScontrinoGestionale");
    throw error;
  }
}

async function ristampaBuono(infoRistampa, numStampante) {
  const service = numStampante ? arrService[numStampante - 1] : arrService[0];
  try {
    const response = await fetch(`${service}/buono/ristampa`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(infoRistampa),
    });
    return await response.json();
  } catch (error) {
    errorService.onError(error, "stampaScontrinoCortesia");
    throw error;
  }
}

async function inviaComandi(commands, settings, numStampante) {
  const service = numStampante ? arrService[numStampante - 1] : arrService[0];
  try {
    const data = {
      commands: commands,
      settings: settings,
    };
    const response = await fetch(`${service}/comandi`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    errorService.onError(error, "inviaComandi");
    return { Request: { printerError: 1001, error: "Errore stampante" } };
  }
}

async function inviaComandiByName(commands, settings, numStampante) {
  const service = numStampante ? arrService[numStampante - 1] : arrService[0];
  try {
    const td = await getTipoDriver();
    const data = {
      commands: commands,
      settings: settings,
    };
    const response = await fetch(`${service}/comandi/name`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    switch (td) {
      case "RCH_PF":
        return {
          status: Object.prototype.hasOwnProperty.call(result, "Request")
            ? "ok"
            : "error",
          error: result.error,
        };
      case "EPSON": // TODO: Verificare come inserire
        return {
          status: "ok",
          error: null,
        };
      default:
        return result;
    }
  } catch (error) {
    errorService.onError(error, "inviaComandi");
    return { Request: { printerError: 1001, error: "Errore stampante" } };
  }
}

async function annullaDocumentoFiscale(fiscale, numStampante) {
  const service = numStampante ? arrService[numStampante - 1] : arrService[0];
  const data = {
    fiscale,
  };
  try {
    const response = await fetch(`${service}/scontrino/delete`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    errorService.onError(error, "annullaDocumentoFiscale");
  }
}

async function displayMessage(righe, numStampante) {
  const service = numStampante ? arrService[numStampante - 1] : arrService[0];
  const data = {
    righe,
  };
  try {
    const response = await fetchTO(`${service}/display`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    errorService.onError(error, "displayMessage");
  }
}

async function setPrinterDate(numStampante) {
  const service = numStampante ? arrService[numStampante - 1] : arrService[0];
  const data = {
    date: new Date(),
  };
  try {
    const response = await fetch(`${service}/date`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    errorService.onError(error, "setPrinterDate");
  }
}

async function getTipoDriver(numStampante) {
  if (!tipoDriver) {
    await printerStatus(numStampante);
  }
  return tipoDriver; // Andrebbe richiamata la funzione di lettura dello stato
}
// eventualmente passare l'id della stampante
async function printerStatus(numStampante) {
  const service = numStampante ? arrService[numStampante - 1] : arrService[0];
  try {
    const response = await fetchTO(`${service}/status`);
    const result = await response.json();
    tipoDriver = result.tipoDriver;
    return result;
  } catch (error) {
    errorService.onError(error, "printerStatus");
    return {
      error: {
        code: "NETWORK_ERROR",
        message: " Errore di comunicazione interno",
      },
    };
  }
}

async function letturaGiornaliera(numStampante) {
  const service = numStampante ? arrService[numStampante - 1] : arrService[0];
  try {
    const response = await fetch(`${service}/giornaliero/lettura`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
    return await response.json();
  } catch (error) {
    errorService.onError(error, "letturaGiornaliera");
  }
}

async function chiusuraGiornaliera(numStampante) {
  const service = numStampante ? arrService[numStampante - 1] : arrService[0];
  try {
    const response = await fetch(`${service}/giornaliero/chiusura`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
    return await response.json();
  } catch (error) {
    errorService.onError(error, "chiusuraGiornaliera");
  }
}

export default {
  getRunMode,
  printRigaScontrino,
  stampaScontrino,
  stampaScontrinoSoloReso,
  stampaScontrinoGestionale,
  inviaComandi,
  inviaComandiByName,
  stampaScontrinoCortesia,
  annullaDocumentoFiscale,
  displayMessage,
  setPrinterDate,
  printerStatus,
  getTipoDriver,
  letturaGiornaliera,
  chiusuraGiornaliera,
  ristampaBuono,
};
